var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.515c89f58ac574be1629e77ad4cccae5.svg#N';
                    var viewUrl = 'sprites.515c89f58ac574be1629e77ad4cccae5.svg#view-N';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 24 24',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };